import { render, staticRenderFns } from "./TherapistList.vue?vue&type=template&id=25499138&scoped=true"
import script from "./TherapistList.vue?vue&type=script&lang=js"
export * from "./TherapistList.vue?vue&type=script&lang=js"
import style0 from "./TherapistList.vue?vue&type=style&index=0&id=25499138&prod&lang=scss&scoped=true"
import style1 from "./TherapistList.vue?vue&type=style&index=1&id=25499138&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25499138",
  null
  
)

export default component.exports